import React, { useState, useEffect, useContext } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { UserContext, getCurrentToken }  from "./context/UserContext";// adjust path if needed

const Sidebar = () => {
  const { signOut } = useContext(UserContext);
  const navigate = useNavigate();
   const [userType, setUserType] = useState("");

  const handleLogout = () => {
    signOut();
    navigate("/login"); // redirect to login page
  };


  useEffect(() => {
  const tokenResponse = getCurrentToken();

  if (!tokenResponse) {
    navigate("/login");
  } else {
    const userToken = tokenResponse.Data.Token;
    const userType = tokenResponse.Data.UserType;

    setUserType(userType);

    // ✅ Check permission after setting userType
   

  }
}, []);

  return (
     <div className="sidebar vh-100 vertical-menu">
      <div className="sidebar-header p-3">
        <div className="navbar-brand-box">
          <a href="/" className="logo logo-light">
            <span className="logo-lg">
              <img src="../acre-africa-full-white-logo.svg" alt="Full Logo Light" height="50" />
            </span>
          </a>
        </div>
      </div>
      <ul className="nav flex-column p-3">
        {/* Admin Dashboard */}
     {(userType === 1 || userType === 3) && (
<li className="nav-item">
          <NavLink to="/Admin" className="nav-link">
            <span class="mdi mdi-view-dashboard-edit"></span>Dashboard
          </NavLink>
        </li>
         )}



         {/* Vendor Section */}
        {(userType === 4) && (
        <li className="nav-item">
          <NavLink to="/" className="nav-link">
            <span className="mdi mdi-view-dashboard"></span> Dashboard
          </NavLink>
        </li>
         )}

       {(userType === 4) && (
          <li className="nav-item">
            <NavLink to="/Products" className="nav-link">
              <span className="mdi mdi-tag-multiple-outline"></span> Products
            </NavLink>
          </li>
           )}
 {(userType ===  4) && (
        <li className="nav-item">
          <NavLink to="/Services" className="nav-link">
            <span className="mdi mdi-toolbox"></span> Services
          </NavLink>
        </li>
 )}
      {(userType === 4) && (
          <li className="nav-item">
            <NavLink to="/orders" className="nav-link">
              <span className="mdi mdi-bookmark-minus"></span> Orders
            </NavLink>
          </li>
       )}


       
          <li className="nav-item">
            <NavLink to="/messages" className="nav-link">
              <span className="mdi mdi-chat"></span> Messages
            </NavLink>
          </li>
      

        <li className="nav-item">
          <NavLink to="/settings" className="nav-link">
            <span className="mdi mdi-cog"></span> Settings
          </NavLink>
        </li>



{/* Admin Section */}
  

        {(userType === 1 || userType === 3) && (
          <li className="nav-item">
            <NavLink to="/Vendors" className="nav-link">
              <span className="mdi mdi-account"></span> Vendors Approvals
            </NavLink>
          </li>
        )}

        {(userType === 1 || userType === 2) && (
          <li className="nav-item">
            <NavLink to="/Commodities" className="nav-link">
              <span className="mdi mdi-toolbox"></span> Sales Approvals
            </NavLink>
          </li>
        )}

        <li className="nav-item mt-3">
          <button onClick={handleLogout} className="nav-link btn btn-danger w-100 text-start">
            <span className="mdi mdi-logout"></span> Logout
          </button>
        </li>
      </ul>
    </div>
  );
};

export default Sidebar;
